import { useEffect, useState } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import Tab1 from './Tab1';
import { UserOutlined, FileProtectOutlined } from '@ant-design/icons';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import OptionSelect from '../../../Types/OptionSelect';
import Tab2 from './Tab2';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import SweetAlert from 'sweetalert2';
import Data from '../../../Data/Data.json';
import { Crypter } from '../../../Functions/Security/Crypter';
import COMPTES from '../../../Models/Comptes';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Tab4 from './Tab4';
import Tab3 from './Tab3';
import RelCpt from '../../../Models/Cpt_R';
import { useNavigate } from 'react-router-dom';
import VerifDay from '../../../Functions/Traitement/VerifDay';


const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === 'light'
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip;
// TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591

function handleClick(event: React.MouseEvent<Element, MouseEvent>) {
  event.preventDefault();
  console.info('You clicked a breadcrumb.');
}



const CompteOrd = () => {
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("");
  const [load, setLoad] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [View, SetView] = useState(false);
  const [dataP, SetdataPCL] = useState<OptionSelect[]>([]);
  const [RelationClient, SetRelationClient] = useState<OptionSelect[]>([]);
  const [SignataireClient, SetSignataireClient] = useState<OptionSelect[]>([]);
  const [Load, SetLoad] = useState(false);
  const Navigate=useNavigate();

  useEffect(() => {
    forceUpdate({});
    if(Load===false)
    {
      VerifDay(user.coduti,user.codage,authHeader,Navigate);
      SetLoad(true);
     }
  }, []);

  interface DataType {
    key: string;
    NUMCPT: string;
    CODREL: string;
    LIMITE: string;
    Nomrel?: string;
    TelRel?: string;
    photo?: string;
    signature?: string;
    cni?: string;
    Expire?: string;
  }

  function initialiazeButton() {
    SeStartSearchG(false)
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {

    localStorage.setItem(Data.LocalVariable.reset, '0');
    setSbmit("add");
    SeStartSearchG(true)
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setAnnulActive(false)
    setConsulActive(true)
    form.resetFields();
    form.setFieldValue("AGCCPT", user.codage);
    form.setFieldValue("lib_AGCCPT", user.agence);
    form.setFieldValue("CDDEVS", 'XAF');
    form.setFieldValue("lib_CDDEVS", 'FRANC CFA BEAC');
  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
  }
  function handleAnulle() {
    let coduti = form.getFieldValue("CODUTI")
    form.resetFields();
    localStorage.clear();
    form.setFieldValue("CODUTI", coduti)
    initialiazeButton();
    localStorage.setItem(Data.LocalVariable.reset, "1");
    form.setFieldValue("AGCCPT", user.codage);
    form.setFieldValue("lib_AGCCPT", user.agence);
    form.setFieldValue("CDDEVS", 'XAF');
    form.setFieldValue("lib_CDDEVS", 'FRANC CFA BEAC');
    SetRelationClient([]);
    SetdataPCL([]);
    SetdataPCL([]);
    localStorage.removeItem(Data.LocalVariable.AyantDCompte);
    localStorage.removeItem(Data.LocalVariable.Relationcompte);
    localStorage.removeItem(Data.LocalVariable.Procurcpt);
    //localStorage.setItem(Data.LocalVariable.resetTable, "1")
  }

  function cunsultButton() 
  {
    setAnnulActive(false)
    setModifActve(false)
  }

  function modifButton() 
  {
    setSbmit("update");
    SeStartSearchG(true)
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }

  const getrelationprocuration = async () => {

    SetdataPCL([]);
    SetRelationClient([]);
    SetSignataireClient([]);


    let datatR: OptionSelect[] = [];
    let datatP: OptionSelect[] = [];
    let datatS: OptionSelect[] = [];

    let data = Crypter.encrypt(form.getFieldValue('NUMCLI'));
    let config1 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetRelation,
      headers: {
        'CypherNumcli': data,
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let config2 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetProcuration,
      headers: {
        'CypherNumcli': data,
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let config3 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetSignataire,
      headers: {
        'CypherNumcli': data,
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let requestOne = axios.request(config1);
    let requestTwo = axios.request(config2);
    let requestTree = axios.request(config3);

    setLoad(true);

    await axios
      .all([requestOne, requestTwo, requestTree])
      .then(
        await axios.spread(async (...responses: any) => {
          const responseOne = responses[0];
          const responseTwo = responses[1];
          const responseTree = responses[2];

          if (responseOne.data) {
            const res = JSON.parse(Crypter.decrypt(responseOne.data));

            if (res.StatutCode === 200) {
              let datas = res.Result.Table;
              if (res.Result.Table.length > 0) {
                datas.map((data: any, indice: number) => {
                  datatR.push({
                    value: data.CODREL,
                    label: data.CODREL + " " + data.NomRel + " " + data.Prenom
                  })
                });
              }

            }

            SetRelationClient(datatR);
          }
          if (responseTwo.data) {
            const res = JSON.parse(Crypter.decrypt(responseTwo.data));
            if (res.StatutCode === 200) {
              let datas = res.Result.Table;
              if (res.Result.Table.length > 0) {
                datas.map((data: any, indice: number) => {
                  datatP.push({
                    value: data.Refprocur,
                    label: data.Refprocur + " " + data.nom + " " + data.prenom
                  })
                });
              }
            }
            SetdataPCL(datatP);
          }

          if (responseTree.data) {
             
            const res = JSON.parse(Crypter.decrypt(responseTree.data));

            if (res.StatutCode === 200) {
              let datas = res.Result.Table;

              if (res.Result.Table.length > 0) {
                datas.map((data: any, indice: number) => {
                  datatS.push({
                    value: data.CODREL,
                    label: data.CODREL + " " + data.NomRel + " " + data.Prenom
                  })
                });
              }
            }

            SetSignataireClient(datatS);
          }

          cunsultButton();

        })).catch(errors => {
          console.error(errors);
        });

    setLoad(false);
    SetView(true);
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Information Client
        </span>
      ),
      children: <Tab1 etatG={StartSearchG} form={form} Function1={getrelationprocuration} Function2={consulte} />,
    },
    {
      key: '2',
      label: (
        <span id='Tab'>
          <FileProtectOutlined />
          Signataire
        </span>
      ),
      children: <Tab2 form={form} OptionSignataire={SignataireClient} />
    }
    ,
    {
      key: '3',
      label: (
        <span id='Tab'>
          <FileProtectOutlined />
          Procuration Client
        </span>
      ),
      children: <Tab3 OptionSignataire={dataP} form={form} />
    }
    ,
    {
      key: '4',
      label: (
        <span id='Tab'>
          <FileProtectOutlined />
          Ayant Droit
        </span>
      ),
      children: <Tab4 OptionSignataire={RelationClient} form={form} />
    }
  ];


  const onFinish = (values: any) => {
    var Compte: COMPTES = values;
    
    Compte.UTILIS = user.coduti;
    Compte.categocpt =''// Compte.categocpt[0];
    Compte.TYPCPT =''
    //
    let dataS = JSON.parse(localStorage.getItem(Data.LocalVariable.Relationcompte) + "");
    let dataP = JSON.parse(localStorage.getItem(Data.LocalVariable.Procurcpt) + "");
    let dataA = JSON.parse(localStorage.getItem(Data.LocalVariable.AyantDCompte) + "");


    let relcptt: RelCpt[] = [];
    let procptt: RelCpt[] = [];
    let ayantcpt: RelCpt[] = [];

    // alert("1"+dataS +"2"+dataA);

    if (dataS !== null) {
      dataS.map((data: any, index: number) => {
        relcptt.push(
          {
            ID: index + 1,
            NUMCPT: data.NUMPCPT,
            CODREL: data.CODREL,
            LIMITE: data.LIMITE
          }
        )
      })
    }

    if (dataP !== null) {
      dataP.map((data: any, index: number) => {
        procptt.push(
          {
            ID: index + 1,
            NUMCPT: data.NUMPCPT,
            CODREL: data.CODREL,
            LIMITE: data.LIMITE
          }
        )
      })
    }

    if (dataA !== null) {
      dataA.map((data: any, index: number) => {
        ayantcpt.push(
          {
            ID: index + 1,
            NUMCPT: data.NUMPCPT,
            CODREL: data.CODREL,
            LIMITE: data.LIMITE
          }
        )
      })
    }

    Compte.ProCpt = procptt;
    Compte.RelCpt = relcptt;
    Compte.AyantCpt = ayantcpt;

    // form.setFieldValue('')

    let typcompte = form.getFieldValue("lib_IDPLAN");


    if (sbmit === "add") {
      

      Compte.DATCRE = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');

      SweetAlert.fire({
        title: "Creation De Compte",
        text: "Voulez-vous creer le Compte de " + Compte.NOMCPT + "  comme " + " " + typcompte + " ?",
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          setLoading(true);
          setIsSubmit(true)
          //let group = profilsDistant.find(()=>)
          console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(Compte)));
   
          let data = Crypter.encrypt(JSON.stringify(Compte));
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.CreateNewCompte,
            headers: {
             //'CypherCompte': data,
              'Authorization': authHeader(),
              'Content-Type': 'application/json'
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              setLoading(false);
              if (response.data) {
                const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                if (res.StatutCode === 200) {

                  form.resetFields()
                  localStorage.clear()
                  setIsSubmit(false)

                
                  SweetAlert.fire({ title: res.Message, text: JSON.stringify(res.Result.Table1).replaceAll("\"COMPTEGL\":",'').replaceAll("{",'').replaceAll("}",'').replaceAll("]",'').replaceAll("[",'').replaceAll("\"",""), icon: "success" })
                  SetSignataireClient([]);
                  SetRelationClient([]);
                
                  localStorage.clear()
                  initialiazeButton()
                  setSbmit("");
                }
                else {
                  SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
                }
              }
            })
            .catch((error) => {
              setLoading(false);
              console.log(error)
              SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });
        }
      })
    }
    // if (sbmit === "update") {
    //   Compte.DATMAJ = user.datjour;
    //   SweetAlert.fire({
    //     title: "Modification de compte",
    //     text: "Voulez-vous modifier compte " + Compte.NUMCPT + " ?",
    //     showCancelButton: true,
    //     color: "green",
    //     confirmButtonText: "Yes",
    //     confirmButtonColor: "green",
    //     cancelButtonColor: "darkred",
    //     cancelButtonText: "No",
    //     showLoaderOnConfirm: true,
    //     icon: 'question'
    //   }).then((res) => {
    //     if (res.isConfirmed) {
    //       setLoading(true);
    //       setIsSubmit(true);
    //       console.log('Received values of form: ', Compte);
    //       let data = Crypter.encrypt(JSON.stringify(Compte));
    //       let config = {
    //         method: 'put',
    //         maxBodyLength: Infinity,
    //         url: Data.ApiUrl.UpdateCompte,
    //         headers: {
    //           // 'CypherCompte': data,
    //           'Authorization': authHeader(),
    //           'Content-Type': 'application/json'
    //         },
    //         data: data
    //       };
    //       axios.request(config)
    //         .then((response) => {
    //           setLoading(false);
    //           if (response.data) {
    //             const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                
    //             if (res.StatutCode === 200) {
    //               form.resetFields();
    //               localStorage.clear();
    //               setIsSubmit(false);
    //               SweetAlert.fire({ title: res.Message, text: res.Result, icon: "success" });

    //               initialiazeButton();

    //               setSbmit("");
    //             }
    //             else {
    //               SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })
    //             }
    //           }
    //         })
    //         .catch((error) => {
    //           setLoading(false);
    //           SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
    //         });
    //     }
    //   })
    // }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {
      errors.push(error.name + "");
    })
    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
  };

  function consulte() {

    let data = Crypter.encrypt(form.getFieldValue("NUMCLI"));
    // let clearNumcli = form.getFieldValue("NUMCLI")
    if (data.length !== 0) {
      //initialiazeButton()
      
      setLoading(true)
      //form.resetFields()
      //form.setFieldValue("NUMCLI", clearNumcli)

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetClient,
        headers: {
          'CypherNumcli': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };


      axios.request(config)
        .then((response) => {
          setLoading(false);
          if (response.data) {
            const res = JSON.parse(Crypter.decrypt(response.data));

            if (res.StatutCode === 200) {
              let datas = res.Result.Table[0]
        
              if (res.Result.Table.length > 0) {

                console.log(datas.lib_catpro);
                form.setFieldValue('CDGESTCLI', datas.CDGEST);
                form.setFieldValue('lib_CDGESTCLI', datas.lib_CDGEST);
                form.setFieldValue('lib_CDPAYS', datas.lib_CDPAYS);
                form.setFieldValue('CDPAYS', datas.CDPAYS);
                form.setFieldValue('CLARIS', datas.CLARIS);
                form.setFieldValue('lib_CLARIS', datas.lib_CLARIS);
                form.setFieldValue('lib_INSTRU', datas.lib_INSTRU);
                form.setFieldValue('INSTRU', datas.INSTRU);
                form.setFieldValue('ETHNIE', datas.ETHNIE);
                form.setFieldValue('lib_ETHNIE', datas.lib_ETHNIE);
                form.setFieldValue('lib_CDENAE', datas.lib_CDENAE);
                form.setFieldValue('CDENAE', datas.CDENAE);
                form.setFieldValue('RESIDECLI', datas.RESIDE);
                form.setFieldValue('lib_RESIDECLI', datas.lib_RESIDE);
                form.setFieldValue('CATPROCLI', datas.CATPRO);
                form.setFieldValue('lib_CATPROCLI', datas.lib_CATPRO);
                 if(datas.PRECLI && datas.PRECLI!==null)form.setFieldValue('NOMCPT', datas.NOMCLI + " " +datas.PRECLI)
                 else form.setFieldValue('NOMCPT', datas.NOMCLI);
                form.setFieldValue('CLECLI', datas.CLECLI);
                form.setFieldValue('TelMobil', datas.telCli);

              } else {
                SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" })
              }
            }
            else {
              SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
            }
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error)
          SweetAlert.fire({ title: "Error", text: error, icon: "error" });
        });
    }
  }

  const consult = async () => {

    let data = Crypter.encrypt(form.getFieldValue("NUMCPT"));
    //let clearNumcli = form.getFieldValue("NUMCPT")
    // alert(data);

    localStorage.removeItem(Data.LocalVariable.AyantDCompte);
    localStorage.removeItem(Data.LocalVariable.Relationcompte);
    localStorage.removeItem(Data.LocalVariable.Procurcpt);

    if (data.length !== 0) {
      initialiazeButton();
      setLoading(true);
      //form.resetFields()
      //form.setFieldValue("NUMCPT", clearNumcli)

      let config1 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetCompte,
        headers: {
          'CypherNumCpte': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      let config2 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetSignCpt,
        headers: {
          'CypherNumCpte': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      let config3 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetProCpt,
        headers: {
          'CypherNumCpte': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };

      let config4 = {
        method: 'get',
        maxBodyLength: Infinity,
        url: Data.ApiUrl.GetAyantCpt,
        headers: {
          'CypherNumCpte': data,
          'Authorization': authHeader(),
          'Content-Type': 'application/json'
        },
      };


      let requestOne = axios.request(config1);
      let requestTwo = axios.request(config2);
      let requestTree = axios.request(config3);
      let requesFour = axios.request(config4);

     await  axios
        .all([requestOne, requestTwo, requestTree, requesFour])
        .then(
          axios.spread(async (...responses: any) => {
            const responseOne = responses[0];
            const responseTwo = responses[1];
            const responseTree = responses[2];
            const responseFour = responses[3];

            if (responseOne.data) {

              localStorage.clear();
              const res = JSON.parse(Crypter.decrypt(responseOne.data));
              if (res.StatutCode === 200) {
                let datas = res.Result.Table[0];
                if (res.Result.Table.length > 0) 
              {


                  form.setFieldsValue(res.Result.Table[0]);
                  //  setLoading(false);

                  form.setFieldValue('lib_NUMCPT', datas.NOMCPT);
                //  form.setFieldValue('categocpt', datas.categocpt + '-' + datas.lib_categocpt);
                  let datat: DataType[] = [];
                  let dataA: DataType[] = [];
                  let dataP: DataType[] = [];
                
                  if (responseTwo.data) {
                   
                    const res = JSON.parse(Crypter.decrypt(responseTwo.data));
                   
                    if (res.StatutCode === 200) {
                      if (res.Result.Table.length > 0) {
                        if (typeof res.Result.Table != 'undefined' || "") {
                          // alert(JSON.stringify(datas));
                          res.Result.Table.map((data: any, indice: any) => {
                            datat.push({
                              key: indice,
                              NUMCPT: data.NUMCPT,
                              CODREL: data.CODREL,
                              LIMITE: data.LIMITE,
                              Nomrel: data.NomRel + " " + data.Prenom,
                              TelRel: data.TelRel,
                              photo: data.photo,
                              signature: data.signature,
                              cni: data.cni
                            })
                          });
                        }
                          
                          if (datat.length > 0) { localStorage.setItem(Data.LocalVariable.Relationcompte, JSON.stringify(datat)) }
                        }
                        }
                        }

                        
                        if (responseTree.data) {
                          const res = JSON.parse(Crypter.decrypt(responseTree.data));
                          if (res.StatutCode === 200) {
                            let datas = res.Result.Table;
                            if (res.Result.Table.length > 0) {
                              if (typeof res.Result.Table != 'undefined' || "") {
                                // alert(JSON.stringify(datat));
                                datas.map((data: any, indice: any) => {
                                  dataP.push({
                                    key: indice,
                                    NUMCPT: data.NUMCPT,
                                    CODREL: data.Refprocur,
                                    LIMITE: data.LIMITE,
                                    Nomrel: data.nom + " " + data.prenom,
                                    TelRel: data.TelProcur,
                                    photo: data.photo,
                                    signature: data.signature,
                                    cni: data.datExpirCni,
                                    Expire: data.DatExpirProcur

                                  })

                                });
                              }
                            }
                          }
                          if (dataP.length > 0) { localStorage.setItem(Data.LocalVariable.Procurcpt, JSON.stringify(dataP)); }
                           }
                        

                       if (responseFour.data) {
                        
                          const res = JSON.parse(Crypter.decrypt(responseFour.data));
                          if (res.StatutCode === 200) {
                            let datas = res.Result.Table;

                            if (res.Result.Table.length > 0) {
                              if (typeof res.Result.Table != 'undefined' || "") {
                                datas.map((data: any, indice: any) => {
                                  dataA.push({
                                    key: indice,
                                    NUMCPT: data.NUMCPT,
                                    CODREL: data.CODREL,
                                    LIMITE: data.LIMITE,
                                    Nomrel: data.NomRel + " " + data.Prenom,
                                    TelRel: data.TelRel,
                                    photo: data.photo,
                                    signature: data.signature,
                                    cni: data.cni
                                  })
                                });
                              }
                            }
                          }
                        }
                          if (dataA.length > 0) { localStorage.setItem(Data.LocalVariable.AyantDCompte, JSON.stringify(dataA)); }

                }
                else {
                  SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                }

                await getrelationprocuration();
              }
              else {
                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
              }

            }
            else {
              SweetAlert.fire({ title: "Warning", text: "Account not found", icon: "error" });
            }

            setLoading(false);
            cunsultButton();
          })
        ).catch(errors => {
          setLoading(false);
          // console.log(error)
          SweetAlert.fire({ title: "Error", text: errors.message, icon: "error" });
        });
    }
    else {
      SweetAlert.fire({ title: "Warning", text: "Account not found", icon: "error" });
    }
  }

  function modif() {

    modifButton()

  }

  return (
    <div className='tab'>
      <Box className='formTitle'> <Breadcrumbs aria-label="breadcrumb">
        <StyledBreadcrumb
          component="a"
          href="/jjh"
          label="Home"
          icon={<HomeIcon fontSize="small" />}
        />
        <StyledBreadcrumb component="a" href="#" label="Gestion" />
        <StyledBreadcrumb
          label="Comptes Odinaires"
          deleteIcon={<ExpandMoreIcon />}
          onDelete={handleClick}
        />
      </Breadcrumbs></Box>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                  Consulter
                </Button>
                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Ajouter
                </Button>
                <Button size='large' className='bt_add' 
                // disabled={modifActve} onClick={modif}
                 disabled={true} 
                 type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add' onClick={SetEndStart} disabled={supActive} type="ghost" htmlType="button" block>
                  Supprimer
                </Button>
                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
            </div>
          </div>
        </Form>
        <div>
          <div>
          </div>
        </div>
      </Spin>
    </div>

  );
}
export default CompteOrd;